import RESOURCE_CATEGORIES from './resourceCategory';
import RESOURCE_CATEGORY_DISPLAY_NAMES from './resourceCategoryDisplayNames';

export const SEARCH_TAB = {
  value: 'search-resources',
  displayName: 'Search Resources'
};

export default [
  {
    value: SEARCH_TAB.value,
    displayName: SEARCH_TAB.displayName
  },
  {
    value: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.GETTING_STARTED].value,
    displayName: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.GETTING_STARTED].name
  },
  {
    value: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.APPRAISAL_VALUE].value,
    displayName: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.APPRAISAL_VALUE].name
  },
  {
    value: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.VIP_ENGAGEMENT].value,
    displayName: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.VIP_ENGAGEMENT].name
  }
];
